import { RefString, RefBool, HandlersCollection, Snack } from "@tblabs/truffle";
import { IStorageUser, OnlineStorage } from "@tblabs/storage";


export class LoginFormLogic
{
    private onLogin = new HandlersCollection<(userInfo: IStorageUser, autologin: boolean) => void>();
    private onLogout = new HandlersCollection<() => void>();
    public PasswordInput = new RefString().Storable("auth-form:password-input");
    public ErrorMessageVisible = new RefBool();
    public LoginInProgress = new RefBool();
    public ErrorMessage = new RefString();

    public ClearForm(): void
    {
        this.PasswordInput.value = "";
        this.ErrorMessageVisible.False();
        this.LoginInProgress.False();
        this.ErrorMessage.value = "";
    }

    public ClearLoginInfo(): void
    {
        // this.LoginInput.value = "";
        this.PasswordInput.value = "";
    }

    public OnLogin(handler: (userInfo: IStorageUser, autologin: boolean) => void): this
    {
        this.onLogin.Add(handler);

        return this;
    }

    public OnLogout(handler: () => void): this
    {
        this.onLogout.Add(handler);

        return this;
    }

    constructor(private _storage: OnlineStorage) 
    {
        this.PasswordInput.OnChange(() =>
        {
            this.ErrorMessageVisible.False();
        });

        _storage.OnUserChange((user: IStorageUser, isAuthorized: boolean) =>
        {
            if (!isAuthorized)
            {
                this.onLogout.Call();
            }
        });
    }

    private autologinSnack?: Snack;
    private autologinFailedSnack?: Snack;

    public CleanUp(): void
    {
        this.autologinFailedSnack?.Close();
        this.autologinFailedSnack = undefined;
        this.autologinSnack?.Close();
        this.autologinSnack = undefined;
    }

    public async TryAutoLogin(): Promise<void>
    {
        try
        {
            if (this._storage.IsNotLoggedIn) // Autologujemy tylko kogoś kto jest w pamięci przeglądarki
            {
                await this._storage.Login(this.PasswordInput.value);
                this.onLogin.Call(this._storage.User, true);
            }
        }
        catch (ex: any)
        {  
            const msg = ex.message.toLowerCase();
            let message;
            
            if (msg.includes("unauthorized"))
            {
                message = "Unauthorized";
            }
            else if (msg.includes("failed to fetch"))
            {
                message = "Connection problem";
            }
            else message = ex.message;
           
            this.autologinFailedSnack = new Snack("❌ Autologin failed", message, { autoCloseTimeout: 0, clickAnywhereToClose: true });
        }
        finally
        {
            this.autologinSnack?.Close();
            this.autologinSnack = undefined;
        }
    }

    public async TryLogin(): Promise<boolean>
    {
        if (this.LoginInProgress.value)
        {
            return false;
        }

        if (!this.PasswordInput.value)
        {
            this.ShowErrorMessage("No password provided");

            return false;
        }

        this.ErrorMessageVisible.False();
        this.LoginInProgress.True();

        try
        {
            await this._storage.Login(this.PasswordInput.value);

            this.LoginInProgress.False();
            this.CleanUp();

            this.onLogin.Call(this._storage.User, false);

            return true;
        }
        catch (ex: any)
        {
            this.LoginInProgress.False();
            this.ShowErrorMessage("Failed to login");

            return false;
        }
    }

    private ShowErrorMessage(message: string): void
    {
        this.ErrorMessage.value = message;
        this.ErrorMessageVisible.True();
    }
}
